import { render, staticRenderFns } from "./ContactListItem.vue?vue&type=template&id=661a0cfe"
import script from "./ContactListItem.vue?vue&type=script&lang=js"
export * from "./ContactListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports